// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"ff5d5c2c","541":"9dfb2d10","703":"42b76b62","787":"1cc6c33a"}[chunkId] + ".chunk.js";
};